import type { ReviewStatus } from "@/types";

export const reviewStatusLabel: Record<ReviewStatus, string> = {
  pending: "Čeka odobrenje",
  approved: "Objavljeno",
  rejected: "Odbijeno",
  hidden: "Skriveno",
};
